import _ from 'lodash';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { SurveyForm } from 'src/app/shared/models/survey/surveyForm';
import { SurveyService } from 'src/app/shared/services/survey.service';
import { AttributeEditorMode } from 'src/app/shared/models/attributes/attributeEditorMode';
import { MembersComponent } from 'src/app/members/members.component';

@Component({
  selector: 'survey',
  templateUrl: './survey.component.html',
  styleUrls: ['./survey.component.scss'],
  standalone: false
})
export class SurveyComponent implements OnInit, OnDestroy {
  private subs: Subscription[] = [];
  private surveySubscription;
  survey: SurveyForm;
  isLoadingOrSaving: boolean = true;
  public surveyHasIntroduction: boolean = false;
  public isSurveyStarted: boolean = false;
  public surveySaved: boolean = false;
  @Input()
  inPreviewMode: boolean = false;
  @Input()
  previewFormId: string;
  @Input()
  onPreviewSurveyStart: Function;
  @Input()
  onPreviewSurveySave: Function;

  get mode(): AttributeEditorMode {
    if (this.inPreviewMode) {
      return AttributeEditorMode.Preview;
    } else {
      return AttributeEditorMode.Application;
    }
  }

  constructor(
    private route: ActivatedRoute,
    private surveyService: SurveyService
  ) {}

  ngOnInit() {
    if (this.inPreviewMode && this.previewFormId) {
      this.surveyService.getForPreview(this.previewFormId);
      this.surveySubscription = this.surveyService.surveyPreview.subscribe((application) => {
        if (application) {
          this.survey = application;
          this.isLoadingOrSaving = false;
          this.surveyHasIntroduction = application.hasIntroduction;
          if (!this.surveyHasIntroduction) {
            this.isSurveyStarted = true;
          } else {
            this.isSurveyStarted = false;
          }
        }
      });
      return;
    }

    let secureLinkId = this.route.snapshot.params['secureLinkId'];
    this.surveyService.getSurveyFormBySecureLinkId(secureLinkId);
    this.subs.push(
      this.surveyService.survey.subscribe((result) => {
        if (result) {
          this.survey = result;
          if (this.survey.form.isPrivate && this.route.parent.component == MembersComponent) {
            location.href = `/portal/forms/survey/${secureLinkId}`;
            return;
          }
          this.surveyService.setSurveyForm();
          this.surveyService.setIsLoadingOrSaving(false);
        }
      }),
      this.surveyService.isLoadingOrSaving.subscribe((result) => {
        this.isLoadingOrSaving = result;
      })
    );
  }

  startSurvey() {
    this.surveyHasIntroduction = false;
    this.isSurveyStarted = true;
  }

  saveSurvey() {
    this.surveyHasIntroduction = false;
    this.isSurveyStarted = false;
    this.surveySaved = true;
  }

  ngOnDestroy(): void {
    this.subs.forEach((x) => x.unsubscribe());
    if (this.surveySubscription) this.surveySubscription.unsubscribe();
  }
}
